import { render, staticRenderFns } from "./ModalLinkResources.vue?vue&type=template&id=64ec3874&"
import script from "./ModalLinkResources.vue?vue&type=script&lang=js&"
export * from "./ModalLinkResources.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports